import Vue from 'vue'
import App from './App'
import createRouter from './router'
import store from './store/index'
import { authInterceptor, errorInterceptor } from './interceptors'
import '@/helpers/leaflet-patch-browser-print'
import LoadScript from 'vue-plugin-load-script'
import VueResource from 'vue-resource'
import Popup from '@/plugins/popup'
import Toast from '@/plugins/toast'
import { mobileCheck } from '@/helpers/utils'
import Vue2TouchEvents from 'vue2-touch-events'
import { env } from '../config'
import { _print, _registerRenderer, getSize, _printAuto } from '@/helpers/overwrittenBrowserPrint'

Vue.config.productionTip = false
L.BrowserPrint.Utils._register = _registerRenderer
L.BrowserPrint.Helper.getSize = getSize
L.BrowserPrint.prototype._print = _print
L.BrowserPrint.prototype._printAuto = _printAuto

Vue.use(VueResource)
Vue.http.interceptors.push(authInterceptor)
Vue.http.interceptors.push(errorInterceptor)

Vue.http.options.root = store.state.backendHostname
Vue.http.options.credentials = true
Vue.prototype.$media = store.state.backendHostname
Vue.prototype.$isMobile = mobileCheck()
Vue.prototype.$SUB_ENV = env.SUB_ENV

const router = createRouter(store)

Vue.use(Toast)
Vue.use(Popup, { store, router })
Vue.use(LoadScript)
Vue.use(Vue2TouchEvents)

const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js